// @ts-nocheck
import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  Button,
  Typography,
  CircularProgress,
  Tooltip,
  ClickAwayListener,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";

import ReusableParentContainer from "../Custom/ReusableParentContainer";
import DotPagination from "../DotPagination/DotPagination";

import { updateEventInfoAction } from "../../store/actions/createEvent";
import { getLatestLogsOfUserAction } from "../../store/actions/logs";
import {
  convertFromUTCToGivenTimezone,
  getTimeAndDateString,
} from "../../utils/methods/dateAndTimeMethods";

import Logo from "../../assets/images/Horizontal_logo.svg";
import Favicon from "../../assets/images/SP_2025_LogoSquare_noBGnolines.svg";
import InfoIcon from "../../assets/images/Info-Square.svg";
import { NotificationIcon } from "../../assets/svgs/SVGs";
import user from "../../assets/images/user.png";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { fetchUnreadNotificationsCount } from "../../store/actions/notifications";
import { isActiveRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import EventNotesNotificationTooltip from "./components/EventNotesNotificationTooltip";
import ChatUnreadTooltip from "./components/ChatUnreadTooltip";
import SupportNavButton from "./SupportNavButton";
import {
  NAV_STACK_MEDIA_QUERY,
  navActionsSx,
  navBellSpacingSx,
  navIdentitySx,
  navShortcutsSx,
} from "./navActionsLayout";
import { ChatBadge } from "./components/NotesBadge";
import RoleSwitcher from "./components/RoleSwitcher";

const PaginationButtonComponent = ({ page, setPage, length, rowsPerPage }) => {
  return (
    <Box
      sx={{
        "& td": {
          display: "block",
        },
      }}
    >
      <DotPagination
        currPage={page}
        setCurrPage={setPage}
        valueLen={length}
        valueOnPerPage={rowsPerPage}
      />
    </Box>
  );
};

const NavBarClient = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const createContactInfo = useSelector((store) => store.createContactInfo);
  const logs = useSelector((store) => store.logs);
  const notifications = useSelector((store) => store.notifications);

  const eventInfo = createContactInfo?.eventInfo;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // Logo: o wordmark horizontal (20rem) vira o quadradinho no MESMO ponto em
  // que a navbar empilha (1200px) — antes a troca era em 600px, então entre
  // 600 e 1200px sobrava um logo de 320px ao lado de um bloco já empilhado.
  const isNavStacked = useMediaQuery(NAV_STACK_MEDIA_QUERY);

  const rowsPerPage = 10;

  // State variables start...
  const [showUserLogs, setShowUserLogs] = useState(false);
  const [page, setPage] = React.useState(0);
  // State variables end...

  // Handlers start...
  const getActivityTimeHandler = ({ activityTime, timezone }) => {
    return getTimeAndDateString(
      convertFromUTCToGivenTimezone({
        dateStr: activityTime,
        timezone,
      }),
    );
  };
  // Handlers end...

  // useEffect start...
  useEffect(() => {
    if (eventInfo && !eventInfo?.userId && auth?.userId && auth?.userToken) {
      if (!isActiveRole(USER_ROLES.CLIENT)) return;
      dispatch(
        updateEventInfoAction({
          payload: {
            userId: auth?.userId,
            ...eventInfo,
          },
          _id: eventInfo?._id,
          successCallback: () => {},
          userAuth: auth,
        }),
      );
    }
  }, [auth?.userId, auth?.userToken, dispatch]);

  React.useEffect(() => {
    if (!auth?.userToken) return;
    dispatch(fetchUnreadNotificationsCount());
    const timer = window.setInterval(() => dispatch(fetchUnreadNotificationsCount()), 30000);
    return () => window.clearInterval(timer);
  }, [auth?.userToken, dispatch]);

  const isConsent = !auth?.termsAcceptedAt || !auth?.smsPermissionStatus;

  // useEffect(() => {
  //   if (showUserLogs) {
  //     // dispatch(getLatestLogsOfUserAction({}));
  //   }
  // }, [showUserLogs, dispatch]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: isSmallScreen ? "25px 10px" : "25px 40px",
        zIndex: 9,
      }}
    >
      <Box>
        <Link
          // FIX #4: this NavBar only renders for the CONTRACTOR active role
          // (see App.jsx). The old logic checked the legacy `userRole` first and
          // sent multi-role accounts (contractor + also client/admin) to
          // `/event/new-requests`, which 404s in the contractor view. Route the
          // logo to the contractor's real landing instead (or /profile when the
          // dashboard is disabled, e.g. an invited/unapproved contractor).
          to={
            auth?.userToken
              ? auth?.disableDashboard
                ? "/profile"
                : "/opportunities"
              : "/"
          }
        >
          <img
            style={{
              width: isNavStacked ? "4.5rem" : "20rem",
            }}
            src={isNavStacked ? Favicon : Logo}
          />
        </Link>
      </Box>

      {auth?.userToken ? (
        <>
          <Box sx={navActionsSx}>
            {/* Atalhos — abaixo de 1200px descem para uma 2ª linha, embaixo
                da identidade (ver navActionsLayout.ts). */}
            <Box sx={navShortcutsSx}>
              {!auth?.disableDashboard && !isConsent ? (
                <EventNotesNotificationTooltip />
              ) : null}
              {!auth?.disableDashboard && !isConsent ? (
                <ChatUnreadTooltip />
              ) : null}
              <SupportNavButton isSmallScreen={isSmallScreen} />

              {!auth?.disableDashboard && !isConsent ? (
                <Box sx={navBellSpacingSx(isSmallScreen)}>
                  <NavLink to={"/notifications"}>
                    <ChatBadge
                      totalUnread={
                        notifications?.notificationsCount
                          ?.unreadNotificationsCount >= 0
                          ? notifications?.notificationsCount
                              ?.unreadNotificationsCount > 99
                            ? `99+`
                            : notifications?.notificationsCount
                                ?.unreadNotificationsCount
                          : ""
                      }
                    >
                      <NotificationIcon
                        style={{
                          // marginTop: "0.35rem",
                          width: "32px",
                          height: "40.25px",
                        }}
                      />
                    </ChatBadge>
                  </NavLink>
                </Box>
              ) : null}
            </Box>

            {/* Identidade: papel + nome + foto. Empilhado fica na 1ª linha,
                acima dos atalhos (column-reverse). */}
            <Box sx={navIdentitySx}>
              {/* Role switcher — aparece se user tem 2+ roles aprovados */}
              <RoleSwitcher />
              <Link to="/profile">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {!isSmallScreen && (
                    <Box>
                      <Typography>
                        Hi,{" "}
                        <Typography variant="span" sx={{ color: "#00EEC5" }}>
                          {auth?.userName}
                        </Typography>
                      </Typography>
                      <Typography>Welcome Back!</Typography>
                    </Box>
                  )}
                  <Box
                    sx={{
                      marginLeft: "8px",
                      width: "64px",
                      height: "64px",
                      borderRadius: "100%",
                      border: "1px solid #D175B6",
                      "& img": {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      },
                    }}
                  >
                    <img
                      src={auth?.imageUrl || user}
                      style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </Box>
                </Box>
              </Link>
              <Typography variant="h1" color="primary"></Typography>
            </Box>
          </Box>

          {/* <Modal
            open={showUserLogs}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            onClose={() => {
              setShowUserLogs(false);
            }}
          >
            <Box
              sx={{
                width: '75%',
                height: '78%',
                color: 'white'
              }}
            >
              <ReusableParentContainer
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '1rem',
                  width: '100%',
                  height: '100%',
                  background: 'rgb(0, 0, 0)'
                }}
              >
                {logs?.recentLogs?.isLoading ? (
                  <CircularProgress size={22} />
                ) : (
                  <>
                    <Typography
                      variant="h3"
                    >
                      Top 10 logs
                    </Typography>
                    <EventLogs 
                      rows={logs?.recentLogs?.data}
                      PaginationButtonComponent={PaginationButtonComponent}
                      paginationButtonComponentProps={{
                        page,
                        setPage,
                        length: rowsPerPage,
                        rowsPerPage
                      }}
                      getActivityTimeHandler={getActivityTimeHandler}
                    />
                  </>
                )}
                
              </ReusableParentContainer>
            </Box>
          </Modal> */}
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <Typography>
              {isSmallScreen ? "" : "Continue as "}
              <Typography
                sx={{ color: "#00EEC5", display: "inline" }}
                // onClick={() => {
                //   // window.location.reload();
                //   navigate("/");
                // }}
              >
                Guest
              </Typography>
            </Typography>
            <Typography>or</Typography>
            <NavLink
              to="/login"
              style={{
                background:
                  "linear-gradient(107.95deg, #FF00FF 0%, #8F00FF 65.99%),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
                borderRadius: "40px",
                padding: isSmallScreen ? "8px 15px" : "8px 35px",
                border: "2px solid white",
              }}
              onClick={() => navigate("/login")}
            >
              LOG IN
            </NavLink>
          </Box>
        </>
      )}
    </Box>
  );
};

PaginationButtonComponent.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func,
  length: PropTypes.number,
  rowsPerPage: PropTypes.number,
};

export default NavBarClient;
